import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { serchSelect, tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { linxutaTaskRank } from "@/api/dataAll/dataAll";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "climbilgTowerSort",
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      more: true,
      value2: [],
      searchData: {
        page: 1,
        page_size: 10,
        server_id: []
      },
      serverLists: [],
      tableData: [],
      Dynamic: [],
      exportdataloading: false
    };
  },
  created: function created() {
    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      this.searchData.page = e;

      if (this.paramsData.server_id) {
        this.searchData.server_id = this.paramsData.server_id;
      } else {
        this.searchData.server_id = "";
      }

      if (this.rawData.game_mark.indexOf('yjfm') == -1) {
        this.searchData.is_prod = this.paramsData.is_prod;
      }

      this.reqLoading = true;
      linxutaTaskRank(this.searchData).then(function (res) {
        if (res.code == 200) {
          _this.tableData = res.data.data || [];
          _this.total = res.data.total;

          _this.$nextTick(function () {
            _this.getTableRight();
          });
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    sizeChange: function sizeChange(e) {
      this.searchData.page_size = e;
      this.searchClick(1);
    },
    exportdata: function exportdata() {
      var _this2 = this;

      this.exportdataloading = true;
      linxutaTaskRank(_objectSpread(_objectSpread({}, this.searchData), {}, {
        page_size: -1
      })).then(function (res) {
        if (res.code == 200) {
          var columns = [{
            label: _this2.$t('game'),
            prop: "game"
          }, {
            label: _this2.$t('platform'),
            prop: "platform"
          }, {
            label: _this2.$t('channel'),
            prop: "channel"
          }, {
            label: _this2.$t('pkg'),
            prop: "pkg"
          }, {
            label: _this2.$t('adChannel'),
            prop: "ad_channel"
          }, {
            label: _this2.$t('adPlacement'),
            prop: "ad_placement"
          }, {
            label: _this2.$t('roleId'),
            prop: "role_id"
          }, {
            label: "user_id",
            prop: "user_id"
          }, {
            label: _this2.$t('climbTower'),
            prop: "task"
          }, {
            label: _this2.$t('time'),
            prop: "time"
          }];

          _this2.$export.excel({
            columns: columns,
            data: res.data,
            title: _this2.$route.meta.title
          });
        }
      }).finally(function () {
        _this2.exportdataloading = false;
      });
    }
  }
};